<template>
  <el-form
     label-position="top"
     @submit.native.prevent="$emit('save')" >
    <h3>{{ myTitle }}</h3>
    <component
       :is="display.container.name"
       v-model="activeName"
       :accordion="display.container.accordion" >
      <component
         :is="display.item.name"
         label="Type"
         title="Type"
         name="type" >
        <el-form-item label="Titre">
          <el-input
             v-model="myTitle"
             placeholder="Title du graphique" />
        </el-form-item>
        <el-form-item label="Type de graphique" >
          <el-select
             v-model="myGraph"
             placeholder="Type de graphique"
             value-key="id">
            <el-option
               v-for="g in graphs"
               :key="g.id"
               :label="g.label"
               :value="g" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox
             v-model="noEmptyInternal"
             @change="() => $emit('update:noEmpty', noEmptyInternal)" >
            Masquer les valeurs vides
          </el-checkbox>
        </el-form-item>
        <el-form-item >
          <template slot="label" >
            Limiter au top
            (<el-checkbox
                v-model="limitStrictInternal"
                @change="() => $emit('update:limitStrict', limitStrictInternal)" >
              strict
            </el-checkbox>)
          </template>
          <el-input-number
             class="limit-results"
             v-model="limitInternal"
             @change="() => $emit('update:limit', limitInternal)" />
        </el-form-item>
      </component>
      <component
         :is="display.item.name"
         label="Mesures"
         title="Mesures"
         name="measure" >
        <measure-hierarchy
           v-model="myMeasure"
           :measure-list="measures"
           :multiple="multipleMeasure" />
      </component>
      <component
         :is="display.item.name"
         label="Dimensions"
         title="Dimensions"
         name="dimension">
        <multiple-cascader
           ref="dimensionCascader"
           v-model="myDimension"
           :min="1"
           add-text="Ajouter une dimension"
           :props="dimensionProps"
           :load-children="dimensionLoad"
           :title="i => 'Dimension ' + (i === 1 ? 'principale' : i)"
           :options="dimensions" />
      </component>
      <component :is="display.item.name" label="Filtres" title="Filtres" name="filter" >
        <filters-editor v-model="myFilter" :dimensions="dimensions" />
      </component>
      <component
        v-if="config"
        :is="display.item.name"
        label="Configuration Spécifique"
        title="Configuration Spécifique"
        name="specialConfig" >
        <component
          :is="config"
          v-model="specialConfigInternal"
          v-bind="specialConfigProps"
          @change="() => $emit('update:specialConfig', specialConfigInternal)" />
      </component>
      <component
         :is="display.item.name"
         label="Style"
         title="Style"
         name="style" >
        <color-scheme-select
          v-model="colorSchemeInternal"
          @change="() => $emit('update:colorScheme', colorSchemeInternal)" />
      </component>
      <component
         :is="display.item.name"
         label="Formattage"
         title="Formattage"
         name="format" >
        <format-config
           v-model="formatsInternal"
           :measures="Array.isArray(measure) ? measure : (measure ? [measure] : [])"
           @change="() => $emit('update:formats', formatsInternal)" />
      </component>
      <component
         :is="display.item.name"
         label="Légende"
         title="Légende"
         name="legend" >
        <el-input-number
          v-model="legendPageSizeInternal"
          :min="0"
          :max="10"
          @change="() => $emit('update:legendPageSize', legendPageSizeInternal || null)" />
      </component>
      <component
         :is="display.item.name"
         label="Avancé"
         title="Avancé"
         name="advanced" >
        <el-form-item>
          <el-input
             v-model="advancedInternal"
             type="textarea"
             :rows="4"
             @change="() => $emit('update:advanced', advancedInternal)" />
        </el-form-item>
      </component>
    </component>
    <div style="text-align: right;" >
      <el-button
         plain
         native-type="submit">
        Sauvegarder
      </el-button>
    </div>
  </el-form>
</template>

<style scoped>
input {
  width: 100%;
}
.default-filter {
    padding: 0 30px;
}
* >>> .el-input-number__decrease {
    top: 6px;
    left: 7px;
}
* >>> .el-input-number__increase {
    top: 6px;
    right: -5px;
}
</style>

<style>
.default-filter .el-select__tags > span {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.default-filter .el-select__tags > span .el-tag {
    width: 100%;
    display: flex;
    align-items: center;
}
.default-filter .el-select__tags-text {
    max-width: 90%;
    min-width: 90%;
    overflow: hidden;
}
.default-filter i.el-tag__close {
    flex-shrink: 0;
}
</style>

<script>
import {Registry as graphs} from './graph'
import MultipleCascader from './MultipleCascader'
import MeasureHierarchy from './MeasureHierarchy'
import ColorSchemeSelect from './ColorSchemeSelect'
import FormatConfig from './FormatConfig'
import FiltersEditor from './components/FiltersEditor'
import * as filters from './filter'
import customGraphApiAware from './mixins/customGraphApiAware'
import api from './api'

export default {
  name: 'macarons-graph-front_graph-edit',
  components: {
    MeasureHierarchy,
    MultipleCascader,
    ColorSchemeSelect,
    FormatConfig,
    FiltersEditor,
    ...filters
  },
  mixins: [
    customGraphApiAware
  ],
  props: {
    title: null,
    graph: null,
    id: null,
    noEmpty: false,
    advanced: null,
    specialConfig: null,
    colorScheme: null,
    formats: null,
    limit: 0,
    limitStrict: false,
    legendPageSize: null,
    measure: null,
    measures: {
      type: [Array, Object],
      default: () => []
    },
    dimension: {
      type: [Array, Object],
      default: () => []
    },
    filter: {
      type: [Array, Object],
      default: () => []
    },
    dimensions: {
      type: [Array, Object],
      default: () => []
    },
    display: {
      type: Object,
      default () {
        return {
          container: {
            name: 'el-tabs',
            accordion: false
          },
          item: {
            name: 'el-tab-pane'
          }
        }
      }
    }
  },
  data () {
    return {
      myTitle: this.title,
      myGraph: this.graph,
      myMeasure: this.measure,
      myDimension: this.dimension,
      myFilter: this.filter,
      noEmptyInternal: this.noEmpty,
      limitInternal: this.limit || 0,
      limitStrictInternal: this.limitStrict || false,
      legendPageSizeInternal: this.legendPageSize || null,
      advancedInternal: this.advanced,
      specialConfigInternal: this.specialConfig,
      colorSchemeInternal: this.colorScheme,
      formatsInternal: this.formats || [],
      activeName: 'type',
      filterOptions: [
        {
          key: 'type',
          options: [
            {key: 'single-select', label: 'Liste de sélection'},
            {key: 'select', label: 'Liste de sélection multiple'},
            {key: 'range', label: 'Plage de donnée'},
            {key: 'hierarchy', label: 'Hiérarchie'}
          ]
        }
      ],
      dimensionProps: {
        label: api.dimension.props.name,
        value: api.dimension.props.uniqueName,
        children: 'children',
        disabled: 'disabled'
      }
    }
  },
  watch: {
    dimensions () {
      if (this.$refs.dimensionCascader) {
        this.$refs.dimensionCascader.updateData()
      }
    },
    myTitle () {
      this.$emit('update:title', this.myTitle)
    },
    myGraph () {
      this.$emit('update:graph', this.myGraph)
    },
    myDimension () {
      this.$emit('update:dimension', this.myDimension)
    },
    myMeasure () {
      this.$emit('update:measure', this.myMeasure)
    },
    myFilter () {
      this.$emit('update:filter', this.myFilter)
    },
    noEmpty () {
      if (this.noEmptyInternal !== this.noEmpty) {
        this.noEmptyInternal = this.noEmpty
      }
    },
    limit () {
      if (this.limit !== this.limitInternal) {
        this.limitInternal = this.limit
      }
    },
    limitStrict () {
      if (this.limitStrict !== this.limitStrictInternal) {
        this.limitStrictInternal = this.limitStrict || false
      }
    },
    legendPageSize () {
      if (this.legendPageSize !== this.legendPageSizeInternal) {
        this.legendPageSizeInternal = this.legendPageSize
      }
    },
    advanced () {
      if (this.advanced !== this.advancedInternal) {
        this.advancedInternal = this.advanced
      }
    },
    specialConfig () {
      if (this.specialConfig !== this.specialConfigInternal) {
        this.specialConfigInternal = this.specialConfig
      }
    },
    colorScheme () {
      if (this.colorScheme !== this.colorSchemeInternal) {
        this.colorSchemeInternal = this.colorScheme
      }
    },
    formats () {
      if (this.formats.length !== this.formatsInternal.length) {
        this.formatsInternal = this.formats.map(f => Object.assign({}, f))
        return
      }
      for (let i = 0; i < this.formats.length; ++i) {
        if (this.formats[i].measure !== this.formatsInternal[i].measure) {
          this.formatsInternal = this.formats.map(f => Object.assign({}, f))
          return
        }
        if (this.formats[i].format !== this.formatsInternal[i].format) {
          this.formatsInternal = this.formats.map(f => Object.assign({}, f))
          return
        }
      }
    }
  },
  computed: {
    multipleMeasure () {
      return this.graph && this.graph.multipleMeasure(this)
    },
    graphs () {
      return graphs.asArray()
    },
    specialConfigProps () {
      const props = {}
      if (this.myGraph && this.myGraph.configProps) {
        this.myGraph.configProps.forEach(prop => {
          props[prop] = this[prop]
        })
      }
      return props
    },
    config () {
      if (!this.myGraph || !this.myGraph.config) {
        return null
      }
      if (typeof this.myGraph.config === 'function') {
        return this.myGraph.config()
      }
      return this.myGraph.config
    }
  },
  methods: {
    dimensionLoad (dimension) {
      this.$store.dispatch('customGraph/loadDimension', this.api.dimension.uniqueName(dimension))
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/CustomGraphEdit.vue